import set from 'lodash/set'
import { z } from 'zod'

import { userProperties } from './BaseModels'
import cachedDummies from './cachedDummies'
import { userPermissions } from './CurrentUser'
import parseModel from './parseModel'

export const basicGroupParser = z.object({
  uuid: z.string(),
  name: z.string(),
})

export const userParser = z.preprocess(
  (o: any) => {
    const permissions = Object.fromEntries(Object.keys(userPermissions).map((name) => [name, false]))
    for (const p of o.permissions || []) {
      set(permissions, p.replace(/^user\./, ''), true)
    }
    o.permissions = permissions
    return o
  },
  z.object({
    ...userProperties,
    groups: z.array(basicGroupParser).default(() => []),
    managedGroups: z.array(basicGroupParser).default(() => []),
    permissions: z.object({
      ...userPermissions,
    }),
  })
)

export type User = z.infer<typeof userParser>

export const dummyUser = cachedDummies(
  (uuid: string, error?: any): User => ({
    isDummy: true,
    error,
    uuid,

    clientUuid: '',

    role: '',
    status: '',
    createdAt: new Date(),

    firstname: 'Berta',
    lastname: 'Brot',
    email: 'berta.brot@example.com',
    username: null,
    avatarUrl: null,

    groups: [],
    managedGroups: [],

    permissions: Object.fromEntries(Object.keys(userPermissions).map((name) => [name, false])) as any,
  })
)

export const parseUser = parseModel<User>(userParser, dummyUser)
